import React from "react";

const Footer = () => {
    return(
        <>
        <footer>
            <div className="footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <img src="/Images/logo.png" />
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div className="quick-link">
                                <h3>Quick Links</h3>
                                <ul>
                                    <li><a href="">Administration</a></li>
                                    <li><a href="">School Hours</a></li>
                                    <li><a href="">Sitemap</a></li>
                                    <li><a href="">Careers</a></li>
                                    <li><a href="">Alumni</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3  col-md-6">
                            <div className="cont-dtl">
                                <h3>Location</h3>
                                <p><i class="bi bi-geo-alt"></i> Civil Line, Mainpuri,(U.P) - 205001 India</p>
                                <p><i class="bi bi-telephone-fill"></i> <a href="tel: +91-7536040116">+91-7536040116</a>, <a href="tel: +91-9557352271">+91-9557352271</a></p>
                                <p><i class="bi bi-envelope"></i> <a href="mailto: ssthomassrschool@gmail.com">ssthomassrschool@gmail.com</a></p>
                                <p><i class="bi bi-globe"></i> <a href="http://www.stthomasmainpuri.com/">www.stthomasmainpuri.com</a></p>
                            </div>
                        </div>
                        
                        <div className="col-lg-3 col-md-6">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14188.425817468424!2d79.059527!3d27.247190449999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39759659f2ad230b%3A0x725a5b10812c9464!2sCivil%20Line%2C%20Mainpuri%2C%20Uttar%20Pradesh%20205001!5e0!3m2!1sen!2sin!4v1712663249822!5m2!1sen!2sin" width="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="d-flex">
                                <div className="app-cont">
                                    <p>Download mobile Apps -A Common Platform For Educators, Parents & Teachers</p>
                                    <div>
                                        <img src="/Images/app1.png" />
                                        <img src="/Images/app2.png" />
                                    </div>
                                    <p className="link">
                                        <a hre="stthomasmainpuri.com">Use URL: stthomasmainpuri.com</a>
                                    </p>
                                </div>
                                <div className="phone-img">
                                    <img src="/Images/app3.png" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                
            </div>
            <img src="/Images/footer-img.png" className="img-fluid" />  
            </footer>
        </>
    )
}
export default Footer;